import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { HelpArticleSummary, HelpCollectionSummary, listHelpArticles } from '../../../services/assistantCentral';
import MessengerHeader from './MessengerHeader';
import { HelpArticleRow } from './MessengerHelp';
import { MESSENGER, messengerSubtitleSx } from './messengerTheme';

interface MessengerCollectionProps {
  collection: HelpCollectionSummary;
  onBack: () => void;
  onClose: () => void;
  onOpenArticle: (slug: string) => void;
}

const MessengerCollection: React.FC<MessengerCollectionProps> = ({ collection, onBack, onClose, onOpenArticle }) => {
  const [articles, setArticles] = useState<HelpArticleSummary[] | null>(null);

  useEffect(() => {
    let alive = true;
    setArticles(null);
    listHelpArticles(collection.id)
      .then((data) => alive && setArticles(data))
      .catch(() => alive && setArticles([]));
    return () => {
      alive = false;
    };
  }, [collection.id]);

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', bgcolor: MESSENGER.surface }}>
      <MessengerHeader title="Ajuda" onBack={onBack} onClose={onClose} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <Box sx={{ px: 2, pt: 2.5, pb: 2, borderBottom: `1px solid ${MESSENGER.border}` }}>
          <Typography component="h2" sx={{ fontWeight: 800, fontSize: '1.15rem', color: MESSENGER.navy, letterSpacing: '-0.01em' }}>
            {collection.title}
          </Typography>
          <Typography sx={{ ...messengerSubtitleSx, mt: 0.5 }}>{collection.description}</Typography>
          <Typography sx={{ fontSize: '0.76rem', color: MESSENGER.slateFaint, mt: 0.75 }}>
            {collection.article_count} {collection.article_count === 1 ? 'artigo' : 'artigos'}
          </Typography>
        </Box>
        {articles === null
          ? [0, 1, 2, 3].map((i) => <Skeleton key={i} height={64} sx={{ mx: 2 }} />)
          : articles.map((a) => <HelpArticleRow key={a.slug} article={a} onOpen={onOpenArticle} />)}
      </Box>
    </Box>
  );
};

export default MessengerCollection;
